import { Component } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";

import { HTMLInputEvent } from "../../../../models";
import { SamlWizardService } from "../saml-wizard.service";
import { TranslateService } from "../../../../common/translate/translate.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { SamlDownloadComponent } from "../saml-download/saml-download.component";
import { SamlAttributesComponent } from "../saml-attributes/saml-attributes.component";

@Component({
	templateUrl: "./saml-upload.component.html"
})
export class SamlUploadComponent extends AbstractWizardStepComponent<void> {
	private metadata = "";
	private isFormInvalid = true;
	private isFileReading = false;

	public form: FormGroup;
	public isAlreadyUploaded = false;
	public isShowExisting = false;
	public fileName = "";

	constructor(
		private service: SamlWizardService,
		private formBuilder: FormBuilder,
		private translateService: TranslateService
	) {
		super();

		this.form = this.formBuilder.group({});

		if (this.service.identityProvider.metadata) {
			this.metadata = atob(this.service.identityProvider.metadata);
		}

		if (!this.isCreate || this.metadata) {
			this.isFormInvalid = false;
			this.isAlreadyUploaded = true;
			this.isShowExisting = true;
		}
	}

	public get isCreate() {
		return this.service.isCreate;
	}

	public fileOnChange($event: HTMLInputEvent) {
		if ($event.target.files) {
			const file = $event.target.files[0];
			// if they do not choose a file do nothing
			if (file !== undefined) {
				this.isFileReading = true;

				const myReader = new FileReader();

				myReader.onloadend = (loadEvent) => {
					this.isFileReading = false;
					this.metadata = String(myReader.result);
					this.fileName = file.name;
				};

				myReader.readAsText(file);
				this.isFormInvalid = false;
			}
		}
	}

	public showFileUpload() {
		this.isFormInvalid = true;
		this.isAlreadyUploaded = false;
	}

	public showAlreadyUploaded() {
		this.isFormInvalid = false;
		this.isAlreadyUploaded = true;
	}

	public get title() {
		return "saml.wizard.upload.title";
	}

	public get description() {
		const args = {
			applicationTitle: this.translateService.translate("application.title"),
			samlIdp1: this.service.identityProvider.name,
			samlIdp2: this.service.identityProvider.name
		};
		return this.translateService.translate("saml.wizard.upload.description", args);
	}

	public get nextStep() {
		return SamlAttributesComponent;
	}

	public get previousStep() {
		return SamlDownloadComponent;
	}

	public get isFormValid() {
		return !this.isFormInvalid;
	}

	public async performPrevious() {
		this.service.processUpload(btoa(this.metadata));
	}

	public async performNext() {
		if (this.form.valid) {
			this.service.processUpload(btoa(this.metadata));
		}
	}

	public get showProgressBar() {
		return this.isFileReading;
	}
}
